import React from "react";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import moment from "moment";

import { ContractDetailTabText } from "./style";
import { formatCurrency } from "../../../../util/formatCurrency";

const ContractDetailTab = () => {
  const {
    adminContractDetails: { contractDetails = {} },
  } = useSelector((state) => state.admin);

  const details = [
    { title: "Ministry Name", value: contractDetails.ministryname || "Not available" },
    { title: "Contract Name", value: contractDetails.contractName || "Not available" },
    { title: "Contract Ref no", value: contractDetails.referenceId },
    { title: "Tender package number", value: contractDetails.packageNumber || "Not available" },
    { title: "Procurement method", value: contractDetails.procurementMethod || "Not available" },
    { title: "Date of award", value: contractDetails.awardDate ? moment(contractDetails.awardDate).format("DD, MMMM, yyyy") : "Not available" },
    { title: "Award Acceptance Date ", value: contractDetails.acceptanceDate ? moment(contractDetails.acceptanceDate).format("DD, MMMM, yyyy") : "Not available" },
    // { title: "Date of awarded contract", value: contractDetails.awardDate ? moment(contractDetails.awardDate).format("DD, MMMM, yyyy") : "Not available" },
    { title: "Contract amount", value: <>&#8358;{formatCurrency(contractDetails.contractAmount)}</> },
    { title: "Contract duration", value: contractDetails.contractDuration + " " + contractDetails.durationType || "Not available" },
    { title: "Start date", value: contractDetails.startdate ? moment(contractDetails.startdate).format("DD, MMMM, yyyy") : "Not available" },
    { title: "End date", value: contractDetails.endDate ? moment(contractDetails.endDate).format("DD, MMMM, yyyy") : "Not available" },
  ];

  return details.map((detail, i) => (
    <Grid key={i} style={{ borderBottom: "1px solid #CBD4DA" }} container>
      <Grid item xs={5}>
        <ContractDetailTabText>{detail.title}</ContractDetailTabText>
      </Grid>
      <Grid item sm style={{ borderLeft: "1px solid #CBD4DA" }}>
        <ContractDetailTabText>{detail.value}</ContractDetailTabText>
      </Grid>
    </Grid>
  ));
};

export default ContractDetailTab;
